export default "__VITE_ASSET__B$xcveW2__"